import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useUniqueSyndicateMembersCount = () => {
  return useQuery({
    queryKey: ["unique-syndicate-members-count"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_unique_syndicate_members_count");
      if (error) throw error;
      return (data as number) ?? 0;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
